// import { CoreApplicationContext } from '@eventbrite/legacy-infra.context-types';
import { FormattedEvent } from '@eventbrite/consumer-search.event-renderer';
import { parseLocationResponse } from '@eventbrite/legacy-infra.redux-destination';
import { FacebookOptions, TopDestinations } from '@/shared/types/App';
import { BucketsContent, FeatureFlags, PopularCities } from '@/shared/types/index';
// import {
//     getSeasonalContent,
//     retrieveHomeFeedState,
//     transformBucketsContent
// } from '../utils';
//import { getHeaderContent } from './header';
//import { transformHeaderContent } from './header/selectors';
import { BaseEnv, Location } from '@/types';

interface MinimalInitialStateProps {
    featureFlags?: FeatureFlags;
    isOnline?: boolean;
    isBotRequest?: boolean;
    env: BaseEnv;
    facebookOptions?: FacebookOptions;
    user?: {
        isAuthenticated?: boolean;
    };
    location?: Location;
}

export const minimalInitialState = (props: MinimalInitialStateProps) => {
    const {
        // experiments,
        // featureFlags,
        isOnline,
        location,
        // isBotRequest,
        env,
        // facebookOptions,
        // user: { isAuthenticated },
    } = props;

    // const seasonalContent = getSeasonalContent({ tld });
    // const browseState = retrieveHomeFeedState({
    //     seasonalContent,
    //     isAuthenticated,
    // });

    // let _header;

    /**
     * We only get the header content when we have the full context loaded
     * to prevent double rendering and getting two images without reason.
     */
    // if (tld) {
    //     /*
    //      * Get a default override in case we don't have any user info but we
    //      * do have an override for the tld for that seasonal.
    //      */
    //     _header = seasonalContent[0]?.byDate?.tldOverrides?.[tld];
    // }
    return {
        // currencyFormat,
        app: {
            //     domain,
            //     tld,
            locale: 'en_US',
            //     experiments,
            //     featureFlags: {
            //         ...featureFlags,
            //     },
            //     isMobile,
            loadingState: {
                isFeLoading: true,
                //         isSearchLoading: false,
                //         isCityBrowseLoading: false,
                //         isProfilesLoading: false,
                //         isOrganizerArticlesLoading: false,
            },
            //     isBotRequest,
            //     uses_language_subdirectory,
        },
        env,
        // content: {
        //     entities: {},
        //     entityContext: [],
        //     flatBucket: [],
        //     browseState: browseState,
        //     seasonal: seasonalContent,
        // },
        // organizers: {
        //     organizersUserFollow: [],
        // },
        location: {
            slug: '',
            placeId: '', //'85977539',
            latitude: 0,
            longitude: 0,
            currentPlace: '', //'New York',
            currentPlaceParent: '',
            placeType: '',
            topSuggestions: [],
            isOnline,
            ...location,
        },
        // search: {
        //     slug: '',
        //     placeId: '',
        //     latitude: '',
        //     longitude: '',
        //     currentPlace: '',
        //     currentPlaceParent: '',
        //     placeType: '',
        //     topSuggestions: [],
        // },
        // user: {
        //     isAuthenticated: false,
        //     publicId: '',
        //     canCreateEvents: true,
        // },
        // shareOptions: {
        //     isMobile,
        //     twitterHandle,
        //     serverUrl,
        //     facebookOptions: {
        //         ...facebookOptions,
        //         locale: facebookLocale,
        //         page: facebookPage,
        //     },
        // },
        // header: {
        //     ..._header,
        // },
    };
};

interface InitialState extends MinimalInitialStateProps {
    buckets: BucketsContent;
    locationSlug?: string;
    latitude?: number;
    longitude?: number;
    placeId?: string;
    currentPlace?: string;
    currentPlaceParent?: string;
    country?: string;
    placeType?: string;
    locations?: string[];
    flatBucket?: {
        result?: FormattedEvent[];
    };
    user: {
        isAuthenticated?: boolean;
        publicId?: string;
        canCreateEvents?: string;
        firstName?: string;
    };
    guestId: string;
    country_popular_cities?: PopularCities;
    top_destinations_for_tld?: TopDestinations;
}

export const getInitialState = (props: InitialState) => {
    const {
        // buckets,
        // experiments,
        // featureFlags,
        // guestId,
        locationSlug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        country,
        placeType,
        locations,
        // flatBucket,
        isOnline,
        // isBotRequest,
        env,
        // facebookOptions,
        // country_popular_cities,
        // top_destinations_for_tld,
        // user: { isAuthenticated, publicId, canCreateEvents, firstName },
    } = props;

    // const seasonalContent = getSeasonalContent({ placeId, tld });
    // const browseState = retrieveHomeFeedState({
    //     seasonalContent,
    //     isAuthenticated,
    // });
    // const { entities, entityContext } = transformBucketsContent(buckets);
    // const organizersUserFollow: string[] = [];

    // let _header;

    /**
     * We only get the header content when we have the full context loaded
     * to prevent double rendering and getting two images without reason.
     */
    // if (currentPlace || placeId || latitude) {
    //     _header = getHeaderContent({
    //         seasonalContent,
    //         tld,
    //         locationSlug,
    //         featureFlags,
    //     });
    // } else if (tld) {
    //     /*
    //      * Get a default override in case we don't have any user info but we
    //      * do have an override for the tld for that seasonal.
    //      */
    //     _header = transformHeaderContent(seasonalContent[0]?.byDate?.tldOverrides?.[tld]);
    // }

    return {
        // currencyFormat,
        app: {
            //     domain,
            //     // tld,
            //     // locale,
            //     experiments,
            //     featureFlags,
            //     isMobile,
            loadingState: {
                isFeLoading: true,
                //         isSearchLoading: false,
                //         isCityBrowseLoading: false,
                //         isProfilesLoading: false,
                //         isOrganizerArticlesLoading: false,
            },
            //     isBotRequest,
            //     country_popular_cities,
            //     top_destinations_for_tld,
        },
        env,
        // content: {
        //     entities,
        //     entityContext,
        //     flatBucket,
        //     browseState,
        //     seasonal: seasonalContent,
        // },
        // organizers: {
        //     organizersUserFollow,
        // },
        location: {
            slug: locationSlug,
            placeId,
            latitude,
            longitude,
            currentPlace,
            currentPlaceParent,
            country,
            placeType,
            topSuggestions: locations ? parseLocationResponse({ places: locations }, null) : [],
            isOnline,
        },
        // search: {
        //     slug: locationSlug,
        //     placeId,
        //     latitude,
        //     longitude,
        //     currentPlace,
        //     currentPlaceParent,
        //     placeType,
        //     topSuggestions: locations ? parseLocationResponse({ places: locations }, null) : [],
        // },
        // user: {
        //     isAuthenticated,
        //     publicId,
        //     canCreateEvents,
        //     firstName,
        //     guestId,
        // },
        // shareOptions: {
        //     isMobile,
        //     twitterHandle,
        //     serverUrl,
        //     facebookOptions: {
        //         ...facebookOptions,
        //         locale: facebookLocale,
        //         page: facebookPage,
        //     },
        // },
        // header: _header,
    };
};
